export default {"src":"/_next/static/media/AffordableSpineCare.1f46b732.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};